package app.nestbridge.feature.messages.presentation

import androidx.compose.runtime.Composable
import app.nestbridge.feature.messages.screen.MessagesEvent
import app.nestbridge.feature.messages.screen.MessagesScreen
import app.nestbridge.feature.messages.screen.MessagesState
import com.slack.circuit.codegen.annotations.CircuitInject
import com.slack.circuit.runtime.presenter.Presenter
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope

@CircuitInject(
    screen = MessagesScreen::class,
    scope = AppScope::class,
)
class MessagesPresenter @Inject constructor() : Presenter<MessagesState> {

    @Composable
    override fun present(): MessagesState {
        return MessagesState(
            eventSink = { _: MessagesEvent ->
                // No-op for now.
            },
        )
    }
}
